import { useState, useEffect } from 'react';




export function getImageUrl(person) {
  return (
    'https://i.imgur.com/' +
    person.imageId +
    's.jpg'
  );
}

// export function getImageSource(optio) {
export function getImageSource(arviointitiedosto) {

  // console.log(optio);
  return (

    // 'arvioinnit/' + arviointitiedosto// toimii (kun images-kansio on publicissa)
    'arvioinnit/' + arviointitiedosto + '.pdf'// toimii (kun images-kansio on publicissa)

  );
}


export const konkatenoiKoonti = (optio, scene) => {
  // optio-parametri sisältää ammattitaitovaatimukset relevantteine kriteereineen sekä tiedon toteutuivatko vai eivät--> tässä voidaan muodostaa niistä lista tms, mikäli tarpeellista raportoinnin kannalta



  let palaute = `Scenessä ${scene} kävi silleestä, että ${optio.koontiteksti}`



  return palaute

}


export const pisteytys = (optio) => {
  //NB lienee tarpeeton koska siirrytty kovakoodattuihin pisteisiin

  // let pisteet = laskePisteet(v1_osaamistaso, v2_osaamistaso, v3_osaamistaso)
  let arvo1 = optio.ammattitaitovaatimus1_osaamistaso
  let ka

  let vaatimustenLkm = optio.ammattitaitovaatimukset.length //1-2, yleensä 1
  if (vaatimustenLkm == 1) {
    ka = optio.ammattitaitovaatimukset[0].osaamistaso
  }
  else if (vaatimustenLkm == 2) {
    ka = (optio.ammattitaitovaatimukset[0].osaamistaso +
      optio.ammattitaitovaatimukset[1].osaamistaso) / 2
  }
  else if (vaatimustenLkm == 3) {//ei pitäisi olla kolmea mutta just in case
    ka = (optio.ammattitaitovaatimukset[0].osaamistaso +
      optio.ammattitaitovaatimukset[1].osaamistaso +
      optio.ammattitaitovaatimukset[2].osaamistaso) / 3
  }

  optio.pisteet = ka;
  return optio


}

export function Mouse() {
  const [mousePos, setMousePos] = useState({});

  useEffect(() => {
    const handleMouseMove = (event) => {
      setMousePos({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener(
        'mousemove',
        handleMouseMove
      );
    };
  }, []);

  return (
    <div>
      Mouse position window x,y {' '}
      <b>
        ({mousePos.x}, {mousePos.y})
      </b>
    </div>
  );
}

export function Mouse2() {
  const [globalMousePos, setGlobalMousePos] = useState({});
  const [localMousePos, setLocalMousePos] = useState({});

  const handleMouseMove = (event) => {
    // 👇 Get mouse position relative to element
    const localX = event.clientX - event.target.offsetLeft;
    const localY = event.clientY - event.target.offsetTop;

    setLocalMousePos({ x: localX, y: localY });
  };

  useEffect(() => {
    const handleMouseMove = (event) => {
      setGlobalMousePos({
        x: event.clientX,
        y: event.clientY,
      });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener(
        'mousemove',
        handleMouseMove
      );
    };
  }, []);

  return (
    <div>
      <div
        style={{
          border: '1px solid red',
          display: 'inline-block',
          padding: '75px',
          textAlign: 'center',
        }}
        onMouseMove={handleMouseMove}
      >
        Local
        <br />
        <b>
          ({localMousePos.x}, {localMousePos.y})
        </b>
      </div>
      <br />
      Global
      <br />
      <b>
        ({globalMousePos.x}, {globalMousePos.y})
      </b>
    </div>
  );
}


const italisoi = (str) => {
  //str sisältää <i>-tagattuja kohtia, jotka pitää italisoida
  // return str.italics()
  //NB enpäs tätä osannutkaan tehdä - merkkaankin vain lainausmerkeillä ne lainaukset
  return str
}